
import { type } from 'os'
import React, { useCallback, useEffect, useState } from 'react'
import Select, { ActionMeta } from 'react-select';
import { ProductTypeService } from '../../services/products/productTypeService';
import useFetch from '../../hooks/useFetch';
import { ProductType } from '../../type/product-type';
import FormGroup from '../bootstrap/forms/FormGroup';
import { Label } from '../icon/material-icons';
import { ReactSelectStyles } from '../../utils/styles';

type StatusSelectorProps = {
    defaultSelected?: string | null;
    name: string;
    onChange: (value: string[]|string) => void;
    isMulti?: boolean;
    discardSelected?: boolean;
    isRequired?: boolean;
}

const ProductTypeSelector: React.FC<StatusSelectorProps> = ({ defaultSelected, isMulti, discardSelected, onChange, isRequired , name}) => {

    const [selectedOption, setSelectedOption] = useState<string[]|string|null>(null);

    // listen for changes in selectedOptions and store in selectedOptions state
    useEffect(() => {
        if (defaultSelected) {
            setSelectedOption(discardSelected ? null : defaultSelected);
        }
    }, [defaultSelected])

    const [data] = useFetch(
        useCallback(async () => {
            const service = new ProductTypeService();
            const response = await service.getProductTypes({all: true});
            return response.getResponseData();
        }, [])
    )

    const _getOptions = (): any[] => {
        let options: any = [];
        if (data) {
            data.productTypes.forEach((item: ProductType) => {
                // if discardSelected is true, discard selected options for not appear in the list
                if(discardSelected && defaultSelected && defaultSelected.length > 0) {
                    let found = defaultSelected == item.id;
                    if(found) {
                        return;
                    }
                }
                options.push({ value: item.id, label: item.name });
            })
        }
        return options;
    }



    const _getDefaultSelectedValues = (): any => {
        let option = null;
        if (selectedOption && data) {
            let optionData = data.productTypes.find((item: ProductType) => item.id == selectedOption);
            option = { value: optionData?.id, label: optionData?.name };
        }
        return option;
    }

    const _handleChange = (newValue: any, actionMeta: ActionMeta<any>) => {
        if (Array.isArray(newValue)) {
            // map for object selected
            let selected = newValue.map((option: any) => option.value);
            setSelectedOption(selected);
            onChange([...selected]);
        } else {
            setSelectedOption(newValue.value);
            onChange(newValue.value);
        }
    }


    // useEffect when selectedOptions changes and call onChange function


    return (
        <FormGroup label='Tipo de producto' requiredInputLabel={isRequired} color={'primary'}>
            <Select styles={ReactSelectStyles} placeholder="Elige un tipo de producto"
                    name={name} isMulti={isMulti} options={_getOptions()} value={_getDefaultSelectedValues()} onChange={_handleChange} />
        </FormGroup>
    )
}

ProductTypeSelector.defaultProps = {
    isMulti: false,
    discardSelected: false,
    isRequired: false
}

export default ProductTypeSelector;
